import './App.css';
import React, { useContext } from 'react';
import {
  BrowserRouter, Routes, Route, Navigate,
} from 'react-router-dom';
import Navbar from './components/navigation/Navbar';
import Home from './pages/home/Home';
import KickCounter from './pages/kick-counter/KickCounter';
import { KickCounterContext } from './context/KickCounterContext';
import Result from './pages/summary/Result';
import ScrollToTop from './components/navigation/ScrollToTop';
import { ROUTE } from './constants/constants';

function App() {
  const { counterMode } = useContext(KickCounterContext);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path={ROUTE.HOME} element={<Home />} />
          <Route
            path={ROUTE.KICK_COUNTER}
            element={counterMode ? <KickCounter /> : <Navigate to={ROUTE.HOME} />}
          />
          <Route
            path={ROUTE.SUMMARY}
            element={counterMode ? <Result /> : <Navigate to={ROUTE.HOME} />}
          />
          <Route path="*" element={<Navigate to={ROUTE.HOME} replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
